import AddIcon from '@mui/icons-material/Add';
import React, { useContext } from 'react';
import { StorageAccountHeaderToolbarProps } from '../Model/StorageAccountProps';
import { PermissionsContext } from '../../UIContainer/PermissionsWrapper';
import PermissionConstants from '../../../Common/Constants/PermissionConstants';
import { Link } from 'react-router-dom';
import HeaderToolbar from '../../../../Common/Components/HeaderToolbar';
import SearchBar from '../../../../Common/Components/Controls/SearchBar';
import CustomButton from '../../../../Common/Components/Controls/InputControls';

const StorageAccountHeaderToolbar = ({
  onFilterRequest,
}: StorageAccountHeaderToolbarProps) => {
  const permissions = useContext(PermissionsContext);
  const hasStorageAccountWritePermission =
    permissions[PermissionConstants.StorageAccountWriter];

  return (
    <HeaderToolbar
      leftContent={<SearchBar onChange={onFilterRequest} width="35%" />}
      rightContent={
        hasStorageAccountWritePermission && (
          <CustomButton
            startIcon={<AddIcon />}
            component={Link}
            to="/storageaccount/create"
            label="Add"
          />
        )
      }
    />
  );
};

export default StorageAccountHeaderToolbar;
